/* eslint-disable no-alert */
import React, { PureComponent } from 'react'
import firebase from 'firebase/app'
import { connect } from 'react-redux'
import Immutable from 'seamless-immutable'
import { Modal, Table, Dropdown, Button } from 'semantic-ui-react'
import moment from 'moment'
import {
  get,
  map,
  find,
  size,
  some,
  chain,
  assign,
  filter,
  pickBy,
  findKey,
  includes
} from 'lodash'

import utils from '../../utils'
import Prototypes  from '../../prototypes'

import EditItemRow from './EditItemRow'
import EditGroupItemRow from './EditGroupItemRow'
import ItemActions from '../../reducers/itemReducer'
import ItemOptionActions from '../../reducers/itemOptionReducer'

class ModalEditOrderItems extends PureComponent {
  state = {
    saving: false,
    dropDownVisible: false,
    unavailableItemKeys: [],
    unavailableItems: {},
    items: {},
    removedItems: {},
  }

  dropDownRef = React.createRef()

  componentWillReceiveProps(nextProps) {
    const { items } = this.props

    if (nextProps.items && nextProps.items !== items) {
      this.setState({ items: nextProps.items })
    }
  }

  componentDidUpdate(prevProps) {
    const { order, getMerchantItems, merchantItems, itemOptions, getItemOptions } = this.props

    if (!prevProps.order && order && !merchantItems[order.restaurant.key]) {
      if (!merchantItems[order.restaurant.key]) {
        getMerchantItems(order.restaurant.key)
        this.getBranchUnavailableItems(order)
      }

      if (!itemOptions[order.restaurant.key]) {
        getItemOptions(order.restaurant.key)
      }
    }
  }

  isUnavailableItemValid = (startedAt, endedAt) => {
    const now = moment().format('x')

    return moment(Number(now)).isBetween(Number(startedAt), Number(endedAt))
  }

  getBranchUnavailableItems = async order => {
    const merchantId = order.restaurant.key
    const branchId = order.restaurant.branch.key

    const unavailableItemRef = firebase
      .firestore()
      .collection('unavailable_items')
      .where('merchant_id', '==', merchantId)
      .where('branch_id', '==', branchId)

    const unavailableSnapshot = await unavailableItemRef.get()

    const unavailableItems = {}
    const unavailableItemKeys = []

    unavailableSnapshot.forEach(doc => {
      const unavailableItemData = doc.data()
      const startedAt = unavailableItemData.started_at || null
      const endedAt = unavailableItemData.ended_at || null

      if (this.isUnavailableItemValid(startedAt, endedAt)) {
        unavailableItemKeys.push(unavailableItemData.item_id)
      }

      unavailableItems[doc.id] = unavailableItemData
    })

    this.setState({ unavailableItemKeys, unavailableItems })
  }

  serializeItemOptions = () => {
    const { unavailableItemKeys } = this.state
    const { order, merchantItems } = this.props

    return map(merchantItems[order.restaurant.key] || [], (item, key) => {
      const unavailableItem = includes(unavailableItemKeys, key)

      const unavailableItemText = unavailableItem ? '- Not Available' : ''

      return {
        key,
        text: `${item.name} ($${item.current_price}) ${unavailableItemText}`,
        value: key,
        disabled: unavailableItem,
        onClick: () => !unavailableItem ? this.onAddItemClick(key) : null,
      }
    })
  }

  isDriverOrderPending = () => {
    const { orders, order } = this.props

    if (order) {
      const nextOrder = find(orders, ({ key }) => key === order.key)

      return (nextOrder && nextOrder.driver_pending_order) || false
    }

    return false
  }

  isItemHasNoOwner = () => {
    const { items } = this.state

    return some(items, item => size(item.belong_to) === 0)
  }

  onSaveClick = () => {
    const { order } = this.props
    const { items } = this.state

    const isDriverPending = this.isDriverOrderPending()
    const isGroupOrder = order.is_group_order

    const isItemHasNoOwner = this.isItemHasNoOwner()

    if (isDriverPending) {
      return alert('You cannot update while the order is waiting for driver to make an action.')
    }

    if (size(items) === 0) {
      return alert('Please add at least one item.')
    }

    if (isGroupOrder && isItemHasNoOwner) {
      return alert('Item cannot add without owner.')
    }

    const confirmation = window.confirm('Are you sure to update the order?')

    if (confirmation) {
      return isGroupOrder ? this.updateGroupOrderItems() : this.updateOrderItems()
    }

    return false
  }

  populateItemOption = itemKey => {
    const { merchantItems: allMerchantItems, itemOptions: allMerchantItemOptions, order } = this.props
    const merchantKey = order.restaurant.key
    const merchantItems = allMerchantItems[merchantKey]
    const merchantItem = merchantItems[itemKey]

    const itemOptions = allMerchantItemOptions[merchantKey]

    return chain(merchantItem.options)
            .pickBy((option, optionKey) => itemOptions[optionKey].is_required)
            .reduce((result, option, optionKey) => {
              const defaultChoice = option.default_choice
              const itemOption = itemOptions[optionKey]

              // eslint-disable-next-line no-param-reassign
              result[optionKey] = {
                option_name: itemOption.name,
                selected_choices: {
                  [defaultChoice]: {
                    name: itemOption.choices[defaultChoice].name,
                    price: option.choices[defaultChoice].price,
                  }
                }
              }

              return result
            }, {})
            .value()
  }

  onAddItemCreateClick = customName => {
    const customValueKey = `custom_${Date.now()}`

    const customData = {
      key: customValueKey,
      value: customValueKey,
      text: customName,
    }

    this.onAddItemClick(customValueKey, customData)
  }

  onAddItemClick = (value, custom = null) => {
    const { order, merchantItems } = this.props
    const { items } = this.state
    const merchantKey = order.restaurant.key

    const itemKey = value

    if (items[itemKey]) {
      return
    }

    if (custom && value.includes('custom')) {
      const itemToAdd = {
        name: custom.text,
        price_at_order: 0,
        quantity: 1,
        special_note: '',
        description: '',
        customable: true,
      }

      this.setState({
        items: {
          ...items,
          [itemKey]: itemToAdd,
        },
        dropDownVisible: false,
      })
    } else {
      const item = merchantItems[merchantKey][itemKey]

      const newItem = {
        item_key: itemKey,
        name: item.name,
        code: item.code || null,
        price_at_order: Number(item.current_price),
        quantity: 1,
        special_note: '',
        description: item.description || '',
        options: Immutable(this.populateItemOption(itemKey)),
      }

      this.setState({
        items: {
          ...items,
          [Date.now()]: newItem,
        },
        dropDownVisible: false,
      })
    }

    this.dropDownRef.clearSearchQuery()
  }

  removeItem = async (key, reason) => {
    const { order } = this.props
    const { saving, items, removedItems } = this.state

    if (saving) {
      return
    }

    const newItems = pickBy(items, (item, itemKey) => itemKey !== key)
    const removedItem = find(items, (item, itemKey) => itemKey === key)
    const shouldSaveToRemovedItem = some(order.items, (item, itemKey) => itemKey === key)

    const newRemovedItem = shouldSaveToRemovedItem && {
      [key] : {
        ...removedItem,
        reason,
        removed_at: Date.now(),
      }
    }

    if (reason === 'out_of_stock') {
      const complete = await this.markItemUnavailable(removedItem)

      if (!complete) return
    }

    this.setState({ items: newItems, removedItems: assign(removedItems, newRemovedItem) })
  }

  markItemUnavailable = async item => {
    try {
      const { order } = this.props
      const { unavailableItemKeys, unavailableItems } = this.state
      const merchantKey = order.restaurant.key
      const branchKey = order.restaurant.branch.key
      const itemKey = item.item_key

      let unavailableItemKey = findKey(unavailableItems, unavailableItem => itemKey === unavailableItem.item_id && unavailableItem.branch_id === branchKey)

      const data = {
        started_at: Number(moment().startOf('day').format('x')),
        ended_at: Number(moment().endOf('day').format('x')),
        branch_id: branchKey,
        merchant_id: merchantKey,
        item_id: itemKey
      }

      const unavailableItemRef = firebase
        .firestore()
        .collection('unavailable_items')

      const confirm = window.confirm(`Are you sure to mark this item unavailable for today?`)

      if (confirm) {
        if (unavailableItemKey) {
          await unavailableItemRef.doc(unavailableItemKey).update(data)
        } else {
          unavailableItemKey = unavailableItemRef.doc().id
          await unavailableItemRef.doc(unavailableItemKey).set(data)
        }

        this.setState({
          unavailableItemKeys: [...unavailableItemKeys, itemKey],
          unavailableItems: {
            ...unavailableItems,
            [unavailableItemKey]: data
          }
        })

        return true
      }
    } catch (error) {
      alert(error.message || error)
    }

    return false
  }

  removeItemFromGroupUser = (itemKey, userKey) => {
    const { items } = this.state

    const item = items[itemKey]

    this.setState({
      items: {
        ...items,
        [itemKey]: {
          ...item,
          belong_to: pickBy(item.belong_to, (val, key) => userKey !== key),
        },
      },
    })
  }

  onItemChange = (itemKey, field, value, userKey = null) => {
    const { items } = this.state

    const item = items[itemKey]

    if (!userKey) {
      this.setState({
        items: {
          ...items,
          [itemKey]: {
            ...item,
            [field]: value,
          },
        },
      })
    } else {
      this.setState({
        items: {
          ...items,
          [itemKey]: {
            ...item,
            belong_to: {
              ...item.belong_to,
              [userKey]: {
                ...item.belong_to[userKey],
                [field]: value,
              },
            },
          },
        },
      })
    }
  }

  onItemOptionClick = (itemUid, optionKey, choiceKey) => {
    const { itemOptions: allMerchantItemOptions, merchantItems: allMerchantItems, order } = this.props
    const { items: orderItems } = this.state

    const orderItem = orderItems[itemUid]
    const itemKey = orderItem.item_key

    const merchantKey = order.restaurant.key
    const merchantItems = allMerchantItems[merchantKey]
    const merchantItem = merchantItems[itemKey]

    const merchantItemOption = merchantItem.options[optionKey]

    const itemOptions = allMerchantItemOptions[merchantKey]
    const originalItemOption = itemOptions[optionKey]

    let orderItemOption = orderItem.options[optionKey] || Immutable({})

    const selectedChoiceCount = size(orderItemOption.selected_choices)
    const isSelected = size(orderItemOption.getIn(['selected_choices', choiceKey])) > 0

    if (isSelected) {
      if (selectedChoiceCount === 1 && originalItemOption.is_required) {
        return null
      }
      orderItemOption = orderItemOption.update('selected_choices', selectedChoice => selectedChoice.without(choiceKey))

      if (size(orderItemOption.selected_choices) === 0) {
        orderItemOption = undefined
      }
    } else {
      const choice = {
        name: originalItemOption.choices[choiceKey].name,
        price: merchantItemOption.choices[choiceKey].price,
      }

      if (originalItemOption.max_choice > selectedChoiceCount) {

        if (selectedChoiceCount === 0) {
          orderItemOption = orderItemOption.set('option_name', originalItemOption.name)
        }

        orderItemOption = orderItemOption.setIn(['selected_choices', choiceKey], choice)
      } else if (!originalItemOption.is_multiple) {
        orderItemOption = orderItemOption.setIn(['selected_choices'], { [choiceKey]: choice })
      } else {
        return null
      }
    }

    const orderItemOptions = orderItemOption
      ? orderItem.options.set(optionKey, orderItemOption)
      : orderItem.options.without(optionKey)


    return this.onItemChange(itemUid, 'options', orderItemOptions)
  }

  quantityChange = (type, itemKey, userKey = null) => {
    const { items } = this.state

    const item = !userKey ? items[itemKey] : items[itemKey].belong_to[userKey]

    const oldQty = Number(item.quantity)
    const nextQty = type === 'increase' ? oldQty + 1 : oldQty - 1

    if (type === 'decrease' && nextQty < 1) {
      if (!userKey) {
        return false
      }

      const userName = item.name
      const confirm = window.confirm(`Are you sure to remove this item from ${userName}?`)

      if (confirm) {
        return this.removeItemFromGroupUser(itemKey, userKey)
      }

      return false
    }

    return this.onItemChange(itemKey, 'quantity', Number(nextQty), userKey)
  }

  priceChange = (newPrice, itemKey) => {
    this.onItemChange(itemKey, 'price_at_order', Number(newPrice))
  }

  specialNoteChange = (newNote, itemKey, userKey = null) => {
    this.onItemChange(itemKey, 'special_note', newNote, userKey)
  }

  nameChange = (newName, itemKey) => {
    this.onItemChange(itemKey, 'name', newName)
  }

  addItemOwner = (itemKey, user) => {
    const { items } = this.state
    const item = items[itemKey]

    this.setState({
      items: {
        ...items,
        [itemKey]: {
          ...item,
          belong_to: {
            ...item.belong_to,
            [user.key]: {
              name: user.name,
              quantity: 1,
              special_note: '',
            },
          },
        },
      },
    })
  }

  getBranchDiscount = async (merchantKey, branchKey, orderType) => {
    const now = Number(moment().format('x'))
    const table = orderType === 'pick-up' ? 'pick_up_discount_promotions' : 'discount_promotions'
    const snapshot = await firebase
      .firestore()
      .collection(`${table}`)
      .where('merchant_id', '==', merchantKey)
      .where('branch_id', '==', branchKey)
      .where('ended_at', '>=', now)
      .get()

    const branchDiscount = snapshot.size > 0 && snapshot.docs[0].data()

    if (branchDiscount && branchDiscount.started_at <= now) return branchDiscount

    return null
  }

  getDeliveryFeeOffer = async (merchantKey, branchKey) => {
    const snapshot = await firebase
      .firestore()
      .collection('delivery_fee_offers')
      .where('merchant', '==', merchantKey)
      .where('branch', '==', branchKey)
      .where('active', '==', true)
      .get()

    let deliveryFeeOffer = null

    if (snapshot.size > 0) deliveryFeeOffer = snapshot.docs[0].data()

    return deliveryFeeOffer
  }

  getSpecialDealItems = async merchantKey => {
    const now = Number(moment().format('x'))

    const snapshot = await firebase
      .firestore()
      .collection('special_deals')
      .where('ended_at', '>=', now)
      .get()

    if (snapshot.size > 0) {
      const specialDeals = {}

      snapshot.forEach(doc => {
        const specialDeal = utils.helpers.filterActiveSpecialDeal(doc.data())

        if (size(specialDeal) > 0) specialDeals[doc.id] = specialDeal
      })

      const specialDealItems = utils.helpers.filterSpecialDealByMerchant(merchantKey, specialDeals)

      return specialDealItems

    }

    return {}
  }

  validateAndRedeemVoucher = async (order, newGrandTotal) => {
    let shouldContinueUpdate = false
    let redemptionResult = null

    try {
      const { items } = this.state
      const { voucher } = order

      const code = get(voucher, 'voucher.code', null)
      if (!code) return null

      const newSubtotal = utils.order.getOrderSubTotal(items)

      const rollbackReason = 'OPT edit order with online payment'
      await Prototypes.Voucherify.rollback(voucher.id, rollbackReason)

      const bodyMetadata = Prototypes.Voucherify.getBodyMetadata(order, newSubtotal, newGrandTotal)

      const result = await Prototypes.Voucherify.validate(code, bodyMetadata)

      if (result.valid) {
        shouldContinueUpdate = true
        redemptionResult = await Prototypes.Voucherify.redeem(code, bodyMetadata)
      } else {
        const confirmContinue = window.confirm(
          `Customer will lose Promo Code, Continue edit order?
          \nReason: ${result.reason} (Current Subtotal: $${newSubtotal})`
        )

        if (confirmContinue) {
          shouldContinueUpdate = true
        } else {
          redemptionResult = await Prototypes.Voucherify.reInvokeVoucher(order)
        }
      }

    } catch (error) {
      shouldContinueUpdate = false
      alert(`Something wrong when apply promo code. \nError: ${error.message || error}`)
    }

    return { shouldContinueUpdate, redemptionResult }
  }

  getSmallOrderFeeData = (dynamicFees, deliveryOffer, subtotal) => {
    const { order } = this.props

    let shouldUpdateData = false
    let orderFeeData = null

    const smallOrderFee = utils.order.getSmallOrderFee(subtotal, deliveryOffer, order)

    const dynamicFeesArr = map(dynamicFees, (fee, key) => ({ ...fee, key }))
    const prevOrderFeeData = find(dynamicFeesArr, fee => /^.[order_fee]/.test(fee.key))

    let prevSmallOrderFee = 0

    if (prevOrderFeeData) {
      prevSmallOrderFee = prevOrderFeeData.fee_amount
    }

    const orderFeeKey = prevOrderFeeData ? prevOrderFeeData.key : null

    if (smallOrderFee > 0 && smallOrderFee !== prevSmallOrderFee) {
      shouldUpdateData = true

      orderFeeData = {
        name: 'Small Order Fee',
        description: "Small order fees apply when an order's subtotal is less than a certain amount. The number varies by stores & the amount you purchase. You can remove the fee by adding more items.",
        fee_amount: smallOrderFee,
        go_to: 'COMPANY',
        type: 'FIXED',
      }
    }

    return {
      orderFeeData,
      smallOrderFee,
      shouldUpdateData,
      orderFeeKey
    }
  }

  getMarkedUpFeeData = (promotionDiscount, subtotal) => {
    const { order } = this.props
    const { restaurant } = order

    const vatRate = restaurant.vat || 0

    const markedUpRate = restaurant.mark_up_percentage || 0
    const markedUpAmount = subtotal * (markedUpRate / 100)

    const vatAmount = utils.order.convertToNumber(subtotal * (vatRate / 100))

    const markedUpVatAmount = utils.order.convertToNumber(vatAmount * (1 + markedUpRate / 100))

    const markedUpPromotionDiscount = promotionDiscount * (1 + markedUpRate / 100)
    const remainingDiscount = markedUpPromotionDiscount - promotionDiscount

    const remainingMarkedUpVat = utils.order.convertToNumber(markedUpVatAmount - vatAmount)
    const markedUpFee = utils.order.convertToNumber(markedUpAmount - remainingDiscount + remainingMarkedUpVat)

    const markedUpFeeData = {
      active: true,
      name: 'Mark up fee',
      description: '--',
      fee_amount: markedUpFee,
      go_to: 'COMPANY',
      type: 'FIXED',
      hidden: true,
    }

    return markedUpFeeData
  }

  getOrderDiscountData = async () => {
    const { order } = this.props
    const { order_type: orderType } = order
    const { items } = this.state

    const { restaurant } = order
    const { key: merchantKey, branch } = restaurant

    const branchKey = branch.key

    const branchDiscount = await this.getBranchDiscount(merchantKey, branchKey, orderType)
    const subtotal = utils.order.getOrderSubTotal(items)
    // const specialDealItems = await this.getSpecialDealItems(merchantKey)
    const specialDealItems = {}
    let promotionEligible = true

    if (branchDiscount && branchDiscount.minimum_amount > subtotal) {
      promotionEligible = false
    }

    const {
      subTotalAfterDiscount,
      selectedItems,
      costSharing
    } = utils.order.getOrderSubtotalWithDiscount(items, branchDiscount, specialDealItems, promotionEligible)

    const promotionDiscount = utils.order.convertToNumber(subtotal - subTotalAfterDiscount)

    return {
      promotionDiscount,
      costSharing,
      selectedItems
    }
  }

  updateOrderItems = async () => {
    try {
      const { order, onCancel } = this.props
      const { items, removedItems } = this.state

      const { key: orderKey, restaurant, voucher } = order
      const { branch } = restaurant
      const markedUpRate = restaurant.mark_up_percentage || 0
      const branchKey = branch.key

      const orderPath = `orders/${orderKey}`
      const branchOrderPath = `branch_orders/${branchKey}/${orderKey}`

      this.setState({ saving: true })

      let promotionDiscountAmount = 0
      let smallOrderFeeAmount = 0
      let markedUpFeeAmount = 0

      const subTotal = utils.order.getOrderSubTotal(items)
      const countItems = utils.order.countOrderItems(items)

      const updates = {}

      updates[`${orderPath}/sub_total`] = subTotal
      updates[`${orderPath}/items`] = items
      updates[`${orderPath}/previous_order_items`] = order.items

      updates[`${branchOrderPath}/sub_total`] = subTotal
      updates[`${branchOrderPath}/items`] = countItems

      const isHasDiscount = Boolean(branch.discount)

      const deliveryOffer = await this.getDeliveryFeeOffer(restaurant.key, branch.key)
      const isChargeSmallOrderFee = deliveryOffer && deliveryOffer.small_order_fee

      if (isChargeSmallOrderFee) {
        const dynamicFees = get(restaurant, 'branch.dynamic_fees', {})

        const {
          shouldUpdateData,
          orderFeeData,
          smallOrderFee,
          orderFeeKey
        } = this.getSmallOrderFeeData(dynamicFees, deliveryOffer, subTotal)

        smallOrderFeeAmount = smallOrderFee

        if (shouldUpdateData) {
          updates[`${orderPath}/restaurant/branch/dynamic_fees/${orderFeeKey}`] = orderFeeData
        }
      }

      if (isHasDiscount) {
        const { promotionDiscount, costSharing, selectedItems } = await this.getOrderDiscountData()

        promotionDiscountAmount = promotionDiscount

        updates[`${orderPath}/cost_sharing`] = costSharing
        updates[`${orderPath}/promotion_discount`] = promotionDiscount
        updates[`${orderPath}/restaurant/branch/discount/items`] = selectedItems
        updates[`${branchOrderPath}/promotion_discount`] = promotionDiscount
      }

      if (markedUpRate > 0) {
        const markedUpFeeData = this.getMarkedUpFeeData(promotionDiscountAmount, subTotal)

        markedUpFeeAmount = markedUpFeeData.markedUpFee

        updates[`${orderPath}/restaurant/branch/dynamic_fees/mark_up_fee`] = markedUpFeeData
      }

      if (voucher) {
        const fees = { smallOrderFeeAmount, markedUpFeeAmount }
        const grandTotal = utils.order.getGrandTotalBeforeVoucherDiscount(order, promotionDiscountAmount, fees, items)

        const { shouldContinueUpdate, redemptionResult } = await this.validateAndRedeemVoucher(order, grandTotal)

        if (!shouldContinueUpdate) {
          this.setState({ saving: false })
          return null
        }

        updates[`${orderPath}/voucher`] = redemptionResult
        updates[`${orderPath}/previous_voucher`] = order.voucher

        updates[`${branchOrderPath}/voucher`] = redemptionResult
      }

      if (order.deliverer) {
        const driverUid = order.deliverer

        updates[`deliverer_orders/${driverUid}/${orderKey}/sub_total`] = subTotal

        if (isHasDiscount) {
          updates[`deliverer_orders/${driverUid}/${orderKey}/promotion_discount`] = promotionDiscountAmount
        }
      }

      if (size(removedItems) > 0) {
        this.updateRemoveOrderItems()
      }

      const err = await firebase
        .database()
        .ref()
        .update(updates)

      if (err) throw err

      this.setState({ saving: false, items: {}, removedItems: {} }, onCancel)
    } catch (error) {
      alert(error.message || error)
      this.setState({ saving: false })
    }
    return null
  }

  updateGroupOrderItems = async () => {
    try {
      const { order, onCancel } = this.props
      const { items, removedItems } = this.state

      const orderKey = order.key
      const branchKey = order.restaurant.branch.key

      const orderPath = `orders/${orderKey}`
      const branchOrderPath = `branch_orders/${branchKey}/${orderKey}`

      const updates = {}

      let discount = 0
      const isHasDiscount = order.promotion_discount > 0

      const subTotal = utils.order.getGroupOrderSubTotal(items)
      const countItems = utils.order.countGroupOrderItems(items)
      const newItems = utils.order.extractGroupOrderItems(items)

      updates[`${orderPath}/sub_total`] = subTotal
      updates[`${orderPath}/items`] = newItems
      updates[`${orderPath}/previous_order_items`] = order.items

      updates[`/branch_orders/${branchKey}/${orderKey}/sub_total`] = subTotal
      updates[`/branch_orders/${branchKey}/${orderKey}/items`] = countItems

      if (isHasDiscount) {
        discount = utils.order.getOrderPromotionDiscount(subTotal, order)

        updates[`${orderPath}/promotion_discount`] = discount
        updates[`${branchOrderPath}/promotion_discount`] = discount
      }

      if (order.deliverer) {
        const driverUid = order.deliverer

        updates[`deliverer_orders/${driverUid}/${orderKey}/sub_total`] = subTotal

        if (isHasDiscount) {
          updates[`deliverer_orders/${driverUid}/${orderKey}/promotion_discount`] = discount
        }
      }

      if (size(removedItems) > 0) {
        this.updateRemoveOrderItems()
      }

      this.setState({ saving: true })

      const err = await firebase
        .database()
        .ref()
        .update(updates)

      if (err) throw err

      this.setState({ saving: false, items: {}, removedItems: {} }, onCancel)
    } catch (error) {
      alert(error.message || error)
      this.setState({ saving: false })
    }
  }

  getRemoteRemoveItems = async () => {
    const { removedItems } = this.state
    const { order } = this.props

    const collection = await firebase
      .firestore()
      .collection('remove_order_items')
      .where('order_id', '==', order.key)
      .get()

    if (collection.size === 0) return null

    const snapshot = collection.docs[0]
    const data = snapshot.data()

    assign(data.items, removedItems)

    return { id: snapshot.id, data }
  }

  updateRemoveOrderItems = async () => {
    const { removedItems } = this.state
    const { order } = this.props

    try {
      const remoteData = await this.getRemoteRemoveItems()
      const ref = firebase.firestore().collection('remove_order_items')

      const id = get(remoteData, 'id', ref.doc().id)
      const data = get(remoteData, 'data', {
        order_id: order.key,
        items: removedItems,
        created_at: Date.now()
      })

      await ref.doc(id).set(data, { merge: true })
    } catch (error) {
      alert(error.message || error)
      this.setState({ saving: false })
    }
  }

  renderGroupItems = () => {
    const { order, items } = this.props
    const { saving } = this.state

    return map(items, (item, itemKey) => {
      const usersNotOwnItem = filter(
        order.group_order.joined_users,
        joinedUser => !(item.belong_to || {})[joinedUser.key]
      )

      return (
        <EditGroupItemRow
          item={item}
          key={itemKey}
          saving={saving}
          itemKey={itemKey}
          usersNotOwnItem={usersNotOwnItem}
          removeItem={reason => this.removeItem(itemKey, reason)}
          addItemOwner={user => this.addItemOwner(itemKey, user)}
          priceChange={e => this.priceChange(e.target.value, itemKey)}
          nameChange={e => this.nameChange(e.target.value, itemKey)}
          increaseQty={userKey => this.quantityChange('increase', itemKey, userKey)}
          decreaseQty={userKey => this.quantityChange('decrease', itemKey, userKey)}
          specialNoteChange={(newNote, userKey) => this.specialNoteChange(newNote, itemKey, userKey)}
        />
      )
    })
  }

  renderItems = () => {
    const { order, merchantItems, itemOptions, itemOptionLoading } = this.props
    const { saving, items } = this.state

    const merchantKey = order.restaurant.key

    return map(items, (item, itemKey) => ((
      <EditItemRow
        item={item}
        key={itemKey}
        saving={saving}
        itemKey={itemKey}
        loading={itemOptionLoading}
        itemOptions={itemOptions[merchantKey]}
        merchantItems={merchantItems[merchantKey]}
        removeItem={reason => this.removeItem(itemKey, reason)}
        nameChange={e => this.nameChange(e.target.value, itemKey)}
        increaseQty={() => this.quantityChange('increase', itemKey)}
        decreaseQty={() => this.quantityChange('decrease', itemKey)}
        priceChange={e => this.priceChange(e.target.value, itemKey)}
        specialNoteChange={e => this.specialNoteChange(e.target.value, itemKey)}
        onItemOptionClick={(optionKey, choiceKey) => this.onItemOptionClick(itemKey, optionKey, choiceKey)}
      />
    )))
  }

  renderContent = () => {
    const { dropDownVisible, saving } = this.state
    const { order, loading } = this.props

    if (!order) return <div />

    const isGroupOrder = order.is_group_order

    return (
      <Table celled compact striped>
        <Table.Header fullWidth>
          <Table.Row>
            <Table.HeaderCell />
            <Table.HeaderCell>Name</Table.HeaderCell>
            <Table.HeaderCell textAlign="center">Quantity</Table.HeaderCell>
            <Table.HeaderCell textAlign="center">Price at order</Table.HeaderCell>
            <Table.HeaderCell>Special Note</Table.HeaderCell>
          </Table.Row>
        </Table.Header>

        <Table.Body>{isGroupOrder ? this.renderGroupItems() : this.renderItems()}</Table.Body>

        <Table.Footer fullWidth>
          <Table.Row>
            <Table.HeaderCell />
            <Table.HeaderCell colSpan={4}>
              <Dropdown
                ref={ref => {
                  this.dropDownRef = ref
                }}
                fluid
                search
                value=""
                selection
                scrolling
                closeOnChange
                allowAdditions
                loading={loading}
                disabled={saving}
                placeholder="Add Item"
                open={dropDownVisible}
                options={this.serializeItemOptions()}
                onFocus={() => this.setState({ dropDownVisible: true })}
                onBlur={() => this.setState({ dropDownVisible: false })}
                onAddItem={(e, { value }) => this.onAddItemCreateClick(value)}
              />
            </Table.HeaderCell>
          </Table.Row>
        </Table.Footer>
      </Table>
    )
  }

  render() {
    const { visible, saving, onCancel } = this.props
    const { items } = this.state

    return (
      <Modal
        open={visible}
        closeOnEscape={false}
        closeOnDimmerClick={false}
        style={{ marginTop: 0, width: '70%' }}
      >
        <Modal.Header>Edit Order Items</Modal.Header>
        <Modal.Content style={{ padding: 0 }}>{this.renderContent()}</Modal.Content>
        <Modal.Actions>
          <Button onClick={() => onCancel()} negative disabled={saving}>
            Cancel
          </Button>
          <Button
            secondary
            icon="save"
            content="Save"
            loading={saving}
            labelPosition="right"
            onClick={this.onSaveClick}
            disabled={saving || size(items) === 0}
          />
        </Modal.Actions>
      </Modal>
    )
  }
}

const mapState = ({ items, itemOptions }) => ({
  loading: items.loading,
  merchantItems: items.data,
  itemOptions: itemOptions.data,
  itemOptionLoading: itemOptions.loading
})

const mapDispatch = {
  getItemOptions: ItemOptionActions.getItemOptions,
  getMerchantItems: ItemActions.fetchItemsByRestaurant,
}

export default connect(mapState, mapDispatch)(ModalEditOrderItems)



// WEBPACK FOOTER //
// ./src/components/orders/ModalEditOrderItems.js